/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Ikhsonstiges12Inputs */

const en__field_enum_ikhsonstiges12 = /** @type {(inputs: _Field_Enum_Ikhsonstiges12Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Other`)
};

const de__field_enum_ikhsonstiges12 = /** @type {(inputs: _Field_Enum_Ikhsonstiges12Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine Anrede`)
};

/**
* | output |
* | --- |
* | "Other" |
*
* @param {_Field_Enum_Ikhsonstiges12Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_ikhsonstiges12 = /** @type {((inputs?: _Field_Enum_Ikhsonstiges12Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Ikhsonstiges12Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_ikhsonstiges12(inputs)
	return de__field_enum_ikhsonstiges12(inputs)
});
export { _field_enum_ikhsonstiges12 as "_field_enum_IKHSONSTIGES" }